import {useFormik} from 'formik';
import {useState} from 'react';
import {CreateProjectStoryDTO, useProjectStories} from '../../../entities';
import * as Yup from 'yup';
import {AxiosError} from 'axios';
import {DateTime} from '@gravity-ui/date-utils';

type UseAddProjectStoryFormProps = {
  setOpen: (open: boolean) => void;
};

export const useAddProjectStoryForm = ({setOpen}: UseAddProjectStoryFormProps) => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const {createProjectStoryMutation} = useProjectStories();

  const onSubmit = async (values: any) => {
    setErrorMessage(null);
    try {
      // Преобразуем дату в строку формата YYYY-MM-DD
      const formattedValues: CreateProjectStoryDTO = {
        title: values.title,
        date: values.date ? values.date.format('YYYY-MM-DD') : '',
        previewImageUploadId: values.previewImageUploadId,
      };

      await createProjectStoryMutation.mutateAsync(formattedValues);
      setOpen(false);
    } catch (error: any) {
      setErrorMessage(error?.response?.data?.detail || 'Произошла ошибка при создании новости проекта');
    }
  };

  const formik = useFormik({
    initialValues: {
      title: '',
      date: null as DateTime | null,
      previewImageUploadId: '',
    },
    validationSchema: Yup.object({
      title: Yup.string().max(256, 'Заголовок не должен превышать 256 символов').required('Заголовок обязателен'),
      date: Yup.mixed().required('Дата обязательна'),
      previewImageUploadId: Yup.string().required('Превью изображение обязательно'),
    }),
    onSubmit,
  });

  return {
    ...formik,
    isLoading: createProjectStoryMutation.isPending,
    submitError: createProjectStoryMutation.error
      ? (createProjectStoryMutation.error as AxiosError<ApiError>).response?.data
      : undefined,
    errorMessage,
    submitForm: () => formik.handleSubmit(),
  };
};
